"use strict";
export const STCComponentMixin = (superClass) => {
  class STCComponentMixinClass extends superClass {
    createRenderRoot() {
      return this;
    }
  }
  return STCComponentMixinClass;
};
